import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import axios from "axios";
import { companyId, userId } from "../../../utils/companyId";
import { validateNumber } from "../../../utils/validateFields";
import { numberError } from "../../../utils/validationMessage";
import SelectField from "../../../Components/Masters/SelectField";
import FileField from "../../../Components/Masters/FileField";
import InputField from "../../../Components/Masters/InputField";
import EditDialog from "../../../Components/Common/EditDialog";
import MonthYearPicker from "../../../Components/Common/MonthYearPicker";
import { post, put } from "../../../utils/api";
import formatTitleWithOptional from "../../Scope1/OptionalFeild";
import { useUser } from "../../../context/AuthContext";
import Multiline from "../../../Components/Masters/Multiline";

function AddData({
  inputData,
  fetchData,
  id,
  title,
  element,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
  handleClose,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});

  const initialState = {
    consumptionPeriod: {
      month: element?.consumptionPeriod?.month || "",
      year: element?.consumptionPeriod?.year || "",
    },
    wasteCategory: element?.wasteCategory || "",
    wasteType: element?.wasteType || "",
    quantityOfWasteGenerated: {
      value: element?.quantityOfWasteGenerated?.value || "",
      unit: element?.quantityOfWasteGenerated?.unit || "Tonnes",
    },
    wasteManagementMethod: element?.wasteManagementMethod || "",
    vendorName: element?.vendorName?._id || "",
    quantityOfWasteManaged: {
      value: element?.quantityOfWasteManaged?.value || "",
      unit: element?.quantityOfWasteManaged?.unit || "Tonnes",
    },
    documents: element?.documents || [],
    editRemarkReason: element?.editRemarkReason || "",
  };

  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});

  const wasteManagementMethods = {
    "Hazardous Waste": ["Incineration", "Landfilling", "Recycling", "Reuse"],
    "Non-Hazardous Waste": [
      "Incineration",
      "Landfilling",
      "Recycling",
      "Reuse",
    ],
    "Construction & Demolition Waste": [
      "Incineration",
      "Landfilling",
      "Recycling",
      "Reuse",
    ],
    Wastewater: ["Incineration", "Landfilling", "Recycling", "Reuse"],
    Aggregates: ["Recycling", "Landfilling"],
    "Average construction": ["Recycling", "Incineration"],
    Asbestos: ["Landfilling"],
    Asphalt: ["Recycling", "Landfilling"],
    Bricks: ["Recycling", "Landfilling"],
    Concrete: ["Recycling", "Landfilling"],
    Insulation: ["Recycling", "Landfilling"],
    Metals: ["Recycling", "Landfilling"],
    Soils: ["Recycling", "Landfilling"],
    "Mineral oil": ["Recycling", "Incineration"],
    Plasterboard: ["Recycling", "Landfilling"],
    Tyres: ["Recycling"],
    Wood: ["Recycling", "Incineration", "Landfilling"],
    Books: ["Recycling", "Incineration", "Landfilling"],
    Glass: ["Recycling", "Incineration", "Landfilling"],
    Clothing: ["Recycling", "Incineration", "Landfilling"],
    "Organic mixed food and garden waste": [
      "Incineration",
      "Landfilling",
      "Composting",
    ],
    "Electrical item": ["Recycling", "Incineration", "Landfilling"],
    Plastic: ["Recycling", "Incineration", "Landfilling"],
    "Paper and board": ["Recycling", "Incineration", "Landfilling"],
  };

  // Component Rendering Logic
  const handleWasteTypeChange = (e) => {
    const selectedWasteType2 = e ? e.target.value : element?.wasteType;
    const managementMethods = wasteManagementMethods[selectedWasteType2] || []; // Default to empty array if no match
    // Update the state for management methods based on the selected waste type
    setSelectedManagementMethods(managementMethods);
    setErrors((prev) => ({ ...prev, wasteType: "" }));
  };

  const [selectedWasteType, setSelectedWasteType] = useState(""); // State for selected waste type
  const [selectedManagementMethods, setSelectedManagementMethods] = useState(
    []
  ); // State for management methods

  useEffect(() => {
    console.log(initialState);
    setFormData(initialState);
    setFormData2(initialState);
    if (id && element) {
      setSelectedWasteType(element.wasteType);
      handleWasteTypeChange();
    }
    setUploadedFiles(element?.documents || []);
  }, [element, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    if (name.startsWith("quantityOfWaste")) {
      const [field, key] = name.split(".");

      setFormData((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          value: value,
        },
      }));

      setErrors((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          value: "",
        },
      }));
    } else if (name === "wasteType")
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        wasteManagementMethod: "",
      }));
    else {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));

      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      console.log(input.fieldName, value);

      if (
        input.fieldName === "quantityOfWasteManaged" &&
        formData.wasteManagementMethod === "Landfilling"
      )
        return;

      if (input.fieldName === "quantityOfWasteGenerated") {
        const cvValue = formData[input.fieldName]?.value || ""; // Ensure it's a string
        const cvUnit = formData[input.fieldName]?.unit || ""; // Ensure it's a string

        if (!validateNumber(cvValue)) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Numeric Value is required.",
          };
        }

        if (!cvUnit.trim()) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            unit: "Unit is required.",
          };
        }
        return; // Ensure to return after handling errors for calorificValue
      }
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;

      if (input.fieldName === "consumptionPeriod") {
        if (!validateNumber(month)) newErrors["month"] = "Month is required";

        if (!validateNumber(year)) newErrors["year"] = "Year is required";

        return;
      }
      if (input.fieldName === "quantityOfWasteManaged") {
        const cvValue = formData[input.fieldName]?.value || ""; // Ensure it's a string
        if (!validateNumber(cvValue)) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Numeric Value is required.",
          };
        } else if (
          Number(formData.quantityOfWasteGenerated?.value) < Number(cvValue)
        ) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Waste Managed must be less than equal to Waste Generated",
          };
        }

        return; // Ensure to return after handling errors for calorificValue
      }

      if (input.type === "number") {
        if (!value) newErrors[input.fieldName] = `${input.title} is required.`;
        else if (!validateNumber(value))
          newErrors[input.fieldName] = numberError;
        return;
      }

      // Handle required fields
      if (
        ((input.type === "text" || input.type === "select") && input.fieldName!=="editRemarkReason") &&
        !value?.trim()
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
      if (element?._id!=="" && user?.endUser && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });
    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) {
      return;
    }

    const url = id ? `${updateUrl}?Id=${id}` : addUrl;
    const dataToSend = { ...formData, documents: uploadedFiles };

    try {
      if (user?.endUser && id) {
        dataToSend.requestStatus = "edit";
        dataToSend.requestMode = true;
        dataToSend.approvalStatus = "Pending";
      }
      const response = id
        ? await put(url, dataToSend)
        : await post(url, dataToSend);

      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });

      fetchData();
      setFormData(initialState);
      setUploadedFiles([]);
      handleClose();
    } catch (error) {
      console.error("Save Error:", error);

      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = error.response.data.errors
          .map((err) => err.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      } else {
        alert(error.message || "An error occurred while saving the data.");
      }
    }
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    setFormData(initialState);
    setFormData2(initialState); // Reset form data to initial state
    setUploadedFiles(element?.documents || []);
    handleClose();
  };

  const handleExit = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key]
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const renderInputField = (el) => {
    if (
      el.fieldName === "quantityOfWasteManaged" &&
      formData?.wasteManagementMethod === "Landfilling"
    )
      return;
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 1 }}>
          <MonthYearPicker
            {...{
              name: el.fieldName,
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
              title: el.title,
              // defaultMonth: formData?.consumptionPeriod?.month || "",
              // defaultYear: formData?.consumptionPeriod?.year || "",
            }}
          />
        </Box>
      );
    }
    // if (
    //   el.fieldName === "quantityOfWasteGenerated" ||
    //   el.fieldName === "quantityOfWasteManaged"
    // ) {
    //   return (
    //     <Box>
    //       <Typography
    //         variant="subtitle1"
    //         sx={{ fontWeight: "bold", mt: 1, mb: -1 }}
    //       >
    //         {el.title}
    //       </Typography>
    //       <Box display="flex" gap={1} sx={{ width: "100%" }}>
    //         <Box sx={{ width: "60%" }}>
    //           <InputField
    //             // title={el.title}
    //             handleChange={handleChange}
    //             placeholder={el.placeholder}
    //             value={formData[el.fieldName]?.value || ""}
    //             errors={errors[el.fieldName]?.value} // Access error for value
    //             fieldName={`${el.fieldName}.value`}
    //           />
    //         </Box>
    //         <Box sx={{ width: "40%" }}>
    //           <SelectField
    //             marginTop="0px"
    //             name={`${el.fieldName}.unit`}
    //             value={formData[el.fieldName]?.unit || ""}
    //             handleChange={handleChange}
    //             options={el.options}
    //             disable={el.fieldName === "quantityOfWasteManaged"}
    //             errors={errors[el.fieldName]?.unit} // Access error for unit
    //             // field={`${el.field}.unit`}
    //             defaultValue="Unit"
    //           />
    //         </Box>
    //       </Box>
    //     </Box>
    //   );
    // }
    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null;
    }
    if (el.type === "select" || el.options) {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          url={el.url}
          field={el.field}
          handleChange={
            el.fieldName === "wasteType"
              ? (e) => {
                  setSelectedWasteType(e.target.value);
                  handleWasteTypeChange(e);
                  handleChange(e);
                }
              : handleChange
          }
          options={
            el.fieldName === "wasteManagementMethod"
              ? selectedManagementMethods
              : el.options
          }
          errors={errors[el.fieldName]}
        />
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={
          el.nested ? formData[el.fieldName]?.value : formData[el.fieldName]
        }
        errors={
          el.nested ? errors[el.fieldName]?.value : errors[el.fieldName] || ""
        }
        fieldName={el.fieldName}
        adornmentText={
          el.fieldName === "quantityOfWasteGenerated" ||
          el.fieldName === "quantityOfWasteManaged"
            ? "Tonnes"
            : ""
        }
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "26rem", maxWidth: "100%" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleExit} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? `Edit ${title} Data` : `Add ${title} Data`}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleExit}
    >
      {list()}
    </Drawer>
  );
}

export default AddData;
